module.exports = "https://coursera_assets.s3.amazonaws.com/images/f3d7b9dbd515c4566211a3f497e47ed5.png";